"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.logExperimentImpression = exports.logExperimentBucketing = exports.isExperimentActive = exports.getExperimentTreatment = exports.experimentBranch = exports.INACTIVE_EXPERIMENT = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _get = _interopRequireDefault(require("lodash/get"));

var _map = _interopRequireDefault(require("lodash/map"));

var _keys = _interopRequireDefault(require("lodash/keys"));

var _pickBy = _interopRequireDefault(require("lodash/pickBy"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _branch = _interopRequireDefault(require("recompose/branch"));

var _lifecycle = _interopRequireDefault(require("recompose/lifecycle"));

var _reactRedux = require("react-redux");

var _mapDispatchToActions = _interopRequireDefault(require("./mapDispatchToActions"));

var _experiments = require("../modules/experiments");

var INACTIVE_EXPERIMENT = 'inactive';
exports.INACTIVE_EXPERIMENT = INACTIVE_EXPERIMENT;

var getExperimentTreatment = function getExperimentTreatment(experimentName, bucket, forcedBucket, defaultVariation) {
  if (defaultVariation === void 0) {
    defaultVariation = 'control';
  }

  var buckets = (0, _extends2["default"])({}, forcedBucket, (0, _pickBy["default"])(bucket, function (value) {
    return value !== INACTIVE_EXPERIMENT;
  }));
  var variation = (0, _get["default"])(buckets, experimentName) || INACTIVE_EXPERIMENT;

  if (variation === INACTIVE_EXPERIMENT) {
    return defaultVariation;
  }

  return variation;
};

exports.getExperimentTreatment = getExperimentTreatment;

var isExperimentActive = function isExperimentActive(experimentName, bucket) {
  return ((0, _get["default"])(bucket, experimentName) || INACTIVE_EXPERIMENT) !== INACTIVE_EXPERIMENT;
};

exports.isExperimentActive = isExperimentActive;

var trackExperimentEvent = function // eventName,
  // experimentName,
  // experimentVariation
trackExperimentEvent() {
  if (typeof window !== 'undefined') {// TODO: Implement the trackExperimentViewLogicHere
  }
};

var logExperimentBucketing = function logExperimentBucketing(bucket) {
  (0, _map["default"])((0, _keys["default"])(bucket), function (name) {
    if (isExperimentActive(name, bucket)) {
      trackExperimentEvent('experiment_bucketing', name, getExperimentTreatment(name, bucket));
    }
  });
};

exports.logExperimentBucketing = logExperimentBucketing;

var logExperimentImpression = function logExperimentImpression(experimentName, experimentVariation) {
  trackExperimentEvent('experiment_impression', experimentName, experimentVariation);
}; // Branches a component tree based on active and forced experiments


exports.logExperimentImpression = logExperimentImpression;

var experimentBranch = function experimentBranch(name, variation, render) {
  return (0, _compose["default"])((0, _reactRedux.connect)(function (_ref) {
    var experiments = _ref.experiments;
    return {
      experiments: experiments
    };
  }, {
    logImpression: _experiments.logImpression
  }, _mapDispatchToActions["default"]), (0, _lifecycle["default"])({
    componentDidMount: function componentDidMount() {
      if (isExperimentActive(name, this.props.experiments.bucket)) {
        this.props.actions.logImpression(name);
      }
    }
  }), (0, _branch["default"])(function (_ref2) {
    var experiments = _ref2.experiments;
    var bucketedVariation = getExperimentTreatment(name, experiments.bucket, experiments.forcedBucket);
    return typeof variation === 'string' ? variation === bucketedVariation : variation.includes(bucketedVariation);
  }, render));
};

exports.experimentBranch = experimentBranch;